import './base/';
import './sliders/product-slider';
import './forms/form-validate';
import './cart/qty';
import './cart/cart';
import './sliders/handleSlider';
import './modal/handleModal';
import './modal/handleVideoModal';
import './modal/handleImageModal';
import './accordions/handleAccordions';
import './tabs/handleTabs';
import './scroll/handleScrollTo';
import './vimeo/handleVimeoBackgroundVideo';
import './pages/handleWrapHalfImage';
import './header/sticky-header';
import './mobile-navigation/mobile-navigation';
import './mobile-navigation/init-navigation';
import './mobile-navigation/close-navigation';
import './product-model/product-model-change';
import './panel/panel-mobile-collapse';
import './equal-height/equal-height';
import './collapse/collapse';
import './compare/change-slider';
import './cart/cart-steps';
